import { Chip } from '@mui/material';

export const renderTagCell = (item: string, isBothTrue?: boolean) => (
  <Chip
    label={item.toUpperCase().replaceAll('_', ' ')}
    sx={{ background: isBothTrue ? 'rgb(0 0 0 / 25%)' : 'rgb(0 0 0 / 8%)' }}
  />
);
